import React from 'react';


const Rules = () => {
  const rules = [
    "Fees are payable in advance. Fees and other charges once paid by the candidate are not refundable in full or in part due to any reason whatsoever nor adjustable against admission of other candidates.",
    "Cheques, Google Pay, Phone Pay, and Bank Draft payable to the Institute are accepted.",
    "All fees have to be paid within the stipulated period, failing which fine shall have to be paid. On very long delayed payment, admission can be cancelled.",
    "The discipline of the Institute is to be strictly observed. For breach of discipline, a student may be fined or expelled from the Institute. No refund of fee will be allowed.",
    "Any harsh or insulting language used in the office or written in the letter may affect the continuity of training.",
    "If a student fails to take an examination for one reason or the other, it may affect the continuity of training.",
    "In all matters, the decision of the Principal will be final.",
    "Any dispute arising out of their transaction will be subject to KAITHAL Jurisdiction only.",
    "Students are not permitted to possess such books which excite Basic Instinct.",
    "The Institute will not be responsible for delay or postponement of the examination by H.N.R.C. Chandigarh.",
    "The Principal/Director reserves the right to change the Time Table at any time.",
    "Leave application is to be got recommended through the class incharge. Application should be signed by the Parents/Guardian.",
    "House Examination/Tests are Compulsory but ill students may remain absent with the permission of the Principal.",
    "Regular and punctual attendance is compulsory at class Demonstration, Practicals, Clinics, Hospitals day & night. 75% attendance is essential to be eligible to appear in the examination.",
    "The Institute does not have any responsibility for any student while going to Hospital/Community experience or while going and coming back from home.",
    "A student whose progress and conduct is considered unsatisfactory, her name may be struck off at any time after giving due notice to the student and his/her parents.",
    "Students will not be allowed to entertain their Parents/Guardians/Relations/Friends during school hours.",
    "Students will not be permitted to go to the cinema.",
    "The Institute does not hold itself responsible for debts incurred by the student.",
    "Students must pay for all the damages caused by them to Library books or other Institutional property.",
    "No student will leave the Hostel or Hospital without permission.",
    "Students are forbidden to accept gifts (in kind or cash) from the patients and their relatives.",
    "Students will take leave pass when going home & will hand over the same to the warden/Principal after getting it signed by the Parents on return.",
    "Repeated misbehaviour, violation of rules, refusal from duty, poor performance in theory & Practical, instigation for strikes & misconduct will be viewed seriously, which can result in expulsion from the Institute without any claims.",
    "Participation in extracurricular activities is compulsory for all students.",
    "Wearing skin-tight and short dresses is strictly prohibited.",
    "Intimacy with male persons in the Hospitals/Field Areas will be viewed seriously and may result in termination of training.",
    "During the Training Period no student will be permitted to appear in any other examination or competition.",
    "The prospective student and her Parents/Guardian must thoroughly study Rules and Regulations and the Eligibility for getting admission into this course.",
  ];

  return (
    <div className="rules-container">
      <div className="rules-card">
        <h3 className="rules-title">Rules and Regulations</h3>
        <div className="rules-list">
          {rules.map((rule, index) => (
            <p key={index} className="rule-item">
              {rule}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rules;
